// The current user's running task timer from users/user_status, shared so
// concurrent callers make one request.
//
// `data` is always an object: when no timer runs, task_id / type_id /
// start_time / elapsed_seconds all come back null. "Is a timer running" must
// therefore be a task_id test, which is what `activeTask` below exists to
// centralise.
//
// Memory-only, like useTextTemplates: it is per-session state that would be
// wrong the moment another user logs in, and logout clears it explicitly.

import { ref, computed } from 'vue';
import axios from '@/services/axios';

const status = ref(null);
// Date.now() of the last successful fetch, so callers can anchor the server's
// elapsed_seconds to the local wall clock and keep ticking between polls.
const receivedAt = ref(0);
let statusPromise = null;

// Null when no timer runs. The four timer fields come back as null in that
// case, so the object itself says nothing — only task_id does.
export const activeTask = computed(() => (status.value?.task_id ? status.value : null));

export { status, receivedAt };

// Concurrent callers share the one in-flight request.
export function fetchUserStatus() {
    if (statusPromise) return statusPromise;

    statusPromise = axios
        .get('users/user_status')
        .then(response => {
            status.value = response.data.data;
            receivedAt.value = Date.now();
            return status.value;
        })
        .catch(error => {
            console.error('Error fetching user status:', error);
            return status.value;
        })
        .finally(() => {
            statusPromise = null;
        });
    return statusPromise;
}

export function clearUserStatus() {
    status.value = null;
    receivedAt.value = 0;
    statusPromise = null;
}
